import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActiveFeedbackService {
  private dialogState = new BehaviorSubject<boolean>(false);

  public showDialog$ = this.dialogState.asObservable();

  public showFeedbackDialog(): void {
    this.dialogState.next(true);
  }
}
